import type { Tag as TagSchema } from '@pique/env/filter';
import type { DocRecord, DocsService } from '@toeverything/infra';
import { Entity, LiveData } from '@toeverything/infra';

import type { TagStore } from '../stores/tag';
import { tagColorMap } from './utils';

export class Tag extends Entity<{ id: string }> {
  id = this.props.id;
  constructor(
    private readonly store: TagStore,
    private readonly docs: DocsService
  ) {
    super();
  }

  private readonly tagOption$ = LiveData.from(
    this.store.watchTagInfo(this.id),
    undefined
  ).map((tagInfo: TagSchema | undefined) => tagInfo);

  value$ = this.tagOption$.map((tag: TagSchema | undefined) => tag?.value || '');

  color$ = this.tagOption$.map((tag: TagSchema | undefined) => tagColorMap(tag?.color ?? '') || '');

  createDate$ = this.tagOption$.map((tag: TagSchema | undefined) => tag?.createDate || Date.now());

  updateDate$ = this.tagOption$.map((tag: TagSchema | undefined) => tag?.updateDate || Date.now());

  rename(value: string) {
    this.store.updateTagInfo(this.id, {
      id: this.id,
      value,
      color: this.color$.value,
      createDate: this.createDate$.value,
      updateDate: Date.now(),
    });
  }

  changeColor(color: string) {
    this.store.updateTagInfo(this.id, {
      color,
    });
  }

  tag(pageId: string) {
    const pageRecord = this.docs.list.doc$(pageId).value;
    if (!pageRecord) {
      return;
    }
    pageRecord?.setMeta({
      tags: [...(pageRecord.meta$.value.tags ?? []), this.id],
    });
  }

  untag(pageId: string) {
    const pageRecord = this.docs.list.doc$(pageId).value;
    if (!pageRecord) {
      return;
    }
    pageRecord?.setMeta({
      tags: pageRecord.meta$.value.tags?.filter((tagId: string) => tagId !== this.id),
    });
  }

  /**
   * @deprecated performance issue here, use with caution until it is fixed
   * @fixme(EYHN): page.meta$ has performance issue
   */
  readonly pageIds$ = LiveData.computed((get: <T>(data: LiveData<T>) => T) => {
    const pages = get(this.docs.list.docs$) as DocRecord[];
    return pages
      .filter((page: DocRecord) => (get(page.meta$) as { tags?: string[] }).tags?.includes(this.id))
      .map((page: DocRecord) => page.id);
  });
}
